/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Check_In_FailInputs */

const en_verify_check_in_fail = /** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to check in. Please try again.`)
};

const es_verify_check_in_fail = /** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al registrar. Inténtalo de nuevo.`)
};

const fr_verify_check_in_fail = /** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'enregistrement. Veuillez réessayer.`)
};

const de_verify_check_in_fail = /** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Einchecken. Bitte versuche es erneut.`)
};

const id_verify_check_in_fail = /** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal check-in. Silakan coba lagi.`)
};

/** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */
const ja_verify_check_in_fail = en_verify_check_in_fail;

/** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */
const zh_verify_check_in_fail = en_verify_check_in_fail;

/** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */
const ar_verify_check_in_fail = en_verify_check_in_fail;

/** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */
const it_verify_check_in_fail = en_verify_check_in_fail;

/** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */
const ru_verify_check_in_fail = en_verify_check_in_fail;

/** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */
const pt_verify_check_in_fail = en_verify_check_in_fail;

/** @type {(inputs: Verify_Check_In_FailInputs) => LocalizedString} */
const ko_verify_check_in_fail = en_verify_check_in_fail;

/**
* | output |
* | --- |
* | "Failed to check in. Please try again." |
*
* @param {Verify_Check_In_FailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_check_in_fail = /** @type {((inputs?: Verify_Check_In_FailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Check_In_FailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_check_in_fail(inputs)
	if (locale === "es") return es_verify_check_in_fail(inputs)
	if (locale === "fr") return fr_verify_check_in_fail(inputs)
	if (locale === "de") return de_verify_check_in_fail(inputs)
	if (locale === "ja") return ja_verify_check_in_fail(inputs)
	if (locale === "zh") return zh_verify_check_in_fail(inputs)
	if (locale === "ar") return ar_verify_check_in_fail(inputs)
	if (locale === "id") return id_verify_check_in_fail(inputs)
	if (locale === "it") return it_verify_check_in_fail(inputs)
	if (locale === "ru") return ru_verify_check_in_fail(inputs)
	if (locale === "pt") return pt_verify_check_in_fail(inputs)
	return ko_verify_check_in_fail(inputs)
});